import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible || isDismissed) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 animate-in slide-in-from-bottom-4 duration-500">
      <div className="flex items-center gap-2 bg-brand-green-700 text-white pl-5 pr-2 py-2.5 rounded-full shadow-lg hover:bg-brand-green-800 transition-colors">
        <Link
          to="/contact"
          className="text-sm font-semibold whitespace-nowrap"
        >
          Get Free Assessment
        </Link>
        <button
          onClick={() => setIsDismissed(true)}
          className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors"
          aria-label="Dismiss"
        >
          <i className="ri-close-line text-sm" />
        </button>
      </div>
    </div>
  );
}